module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0141.jpg?v=f0b42a7d";